import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { textGray } from '../utils/colors';

const StyledProgressPositioner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${props =>
    !props.nonAbsolute &&
    css`
      width: 80%;
      bottom: 1rem;
      position: absolute;
    `};
`;

const StyledPercentage = styled.span`
  font-weight: 600;
  font-size: 0.875rem;
  flex-shrink: 0;
  width: 3em;
  text-align: right;
  color: ${textGray};

  ${props =>
    props.inverted &&
    css`
      color: #ffffff;
    `};
`;

const StyledProgressContainer = styled.div`
  position: relative;
  width: 80%;
  background: #d4fdf7;
  height: 5px;
`;

const StyledProgressCounter = styled.div`
  transition: width 1s ease-in-out;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: ${props => props.width}%;
  background-color: ${props => props.theme.tertiary};

  ${props =>
    props.hasGradient &&
    css`
      background: linear-gradient(
        to right,
        rgba(0, 115, 100, 1) 0%,
        rgba(125, 185, 232, 0) 100%
      );
    `};
`;

const ProgressBar = ({ progress, nonAbsolute, inverted }) => {
  return (
    <StyledProgressPositioner nonAbsolute={nonAbsolute}>
      <StyledProgressContainer>
        <StyledProgressCounter width={progress} hasGradient={false} />
      </StyledProgressContainer>
      <StyledPercentage inverted={inverted}>{progress}%</StyledPercentage>
    </StyledProgressPositioner>
  );
};

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  nonAbsolute: PropTypes.bool
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/ProgressBar.js